import React, {
  useState
} from 'react';
import {
  Button,
  DatePicker,
  Input,
  message,
  TimePicker,
  Upload
} from 'antd';
import type { UploadFile, UploadProps } from 'antd/es/upload/interface';
import {
  CloudUploadOutlined,
  CopyOutlined,
  LeftOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

import styles from './index.module.scss';

const { Dragger } = Upload;

interface Props {};

const BANK_ACCOUNT_NUMBER = '4681094557';

const BuyerConfirmPayment: React.FC<Props> = (props) => {
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const navigate = useNavigate();

  const [file, setFile] = useState(null);

  const onImageChange: UploadProps['onChange'] = async ({ fileList }) => {
    setFileList(fileList);
  };

  const uploadProps: UploadProps = {
    listType: 'picture-card',
    accept: 'image/*',
    fileList: fileList,
    onChange: (e) => {
      onImageChange(e)
    },
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    maxCount: 1,
    beforeUpload: (file) => {
      const isImgFile = file.type === 'image/png' || file.type === 'image/jpeg';
      if (!isImgFile) {
        message.error(`${file.name} ฟอร์แมตไม่ถูกต้อง\nกรุณาอัพโหลดไฟล์​ .png หรือ .jpg`);
      }
      return isImgFile || Upload.LIST_IGNORE;
    },
    customRequest: ({ file, onSuccess }: any) => {
      setFile(file)
      onSuccess();
    }
  };

  const handleBacktrack = () => {
    navigate({
      pathname: '/profile/service-orders'
    })
  }

  return (
    <>
      <div className={styles.spacer}>
        <div
          className={styles.backtrackM}
          onClick={handleBacktrack}
        >
          <LeftOutlined />
          <span className={styles.backtrackLabel}>คำสั่งซื้อบริการของฉัน</span>
        </div>
      </div>
      <div className={[styles.container, styles.txt].join(' ')}>
        <div
          className={styles.backtrack}
          onClick={handleBacktrack}
        >
          <LeftOutlined />
          <span className={styles.backtrackLabel}>คำสั่งซื้อบริการของฉัน</span>
        </div>
        <div className={styles.primaryHeader}>
          กรุณาชำระเงินเพื่อยืนยันการประเมินหน้างาน
        </div>
        <div>
          เพื่อยืนยันการประเมินหน้างานกับช่างที่คุณเลือก
        </div>
        <div className={styles.content}>
          <div className={styles.contentPane}>
            <div className={styles.bankAccBg}>
              <div className={styles.bankLogo}>
                <img
                  className={styles.logo}
                  src='/images/scb-logo.svg'
                  alt=''
                />
              </div>
              <div className={styles.bankInfo}>
                <div className={styles.bold}>
                  เลขที่บัญชี: 468-1094557
                </div>
                <div>
                  เอสซีจี ดิสทริบิวชั่น จำกัด(พร้อมดี)
                </div>
              </div>
            </div>
            <div className={styles.info}>
              <div className={styles.topic}>จำนวนเงิน:</div>
              <div>{ '20.00 บาท' }</div>
            </div>
            <div className={styles.info}>
              <div className={styles.topic}>ชื่อบัญชี:</div>
              <div>{ 'เอสซีจี ดิสทริบิวชั่น จำกัด(พร้อมดี)' }</div>
            </div>
            <div className={styles.info}>
              <div className={styles.topic}>เลขบัญชี:</div>
              <div className={styles.bankNum}>
                <div>{ '468-1094557' }</div>
                <div
                  className={styles.copyBtn}
                  onClick={() => navigator.clipboard.writeText(BANK_ACCOUNT_NUMBER)}
                >
                  <CopyOutlined />
                  <span>คัดลอก</span>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.contentDivider}></div>
          <div className={styles.contentPane}>
            <div className={styles.confirmHeaderTxt}>
              แจ้งชำระเงิน
            </div>
            <div className={styles.info}>
              <div className={styles.topic}>จำนวนเงิน:</div>
              <div className={styles.input}>
                <Input placeholder='จำนวนเงิน' />
              </div>
            </div>
            <div className={styles.info}>
              <div className={styles.topic}>วันที่โอน:</div>
              <DatePicker
                className={styles.input}
                placeholder='เลือกวันที่โอน'
              />
            </div>
            <div className={styles.info}>
              <div className={styles.topic}>เวลาที่โอน:</div>
              <TimePicker
                className={styles.input}
                placeholder='เลือกเวลาที่โอน'
              />
            </div>
            <div
              className={styles.info}
              style={{ flexDirection: 'column', alignItems: 'flex-start' }}
            >
              <div>รูปภาพสลิปการโอนเงิน:</div>
              <div className={styles.uploadContainer}>
                <Dragger {...uploadProps}>
                  <div className={styles.upload}>
                    <p className='ant-upload-drag-icon'>
                      <CloudUploadOutlined />
                    </p>
                    <p className='ant-upload-text'>
                      คลิกเพื่ออัพโหลดรูปภาพ
                    </p>
                    <p className='ant-upload-hint'>
                      .png / .jpg
                    </p>
                  </div>
                </Dragger>
              </div>
            </div>

            <div>
              <Button
                className={styles.confirmBtn}
              >
                แจ้งชำระเงิน
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default BuyerConfirmPayment;
